import { IS_B2B_BIZ_USER, IS_BIZ_USER, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { features } from 'reactApp/mail-features';

const constraints = !IS_BIZ_USER && !IS_B2B_BIZ_USER && !IS_ONPREMISE;

/**
 * CLOUDWEB-19871
 * Общая фича для включения возможности сейфования в чистилке для писем и файлов
 * Фичи настройки кнопки сейфа Облака в reactApp/appHelpers/featuresHelpers/features/overquotaSafe.ts
 */
export const quotaCleanerSafeEnable: boolean = constraints && features.has('quota-cleaner-safe-enable');
// Показывать кнопку перемещения писем в сейф независимо от того, оверквотник ли юзер
export const quotaCleanerSafeSkipMailOverquotaCheck: boolean = constraints && features.has('quota-cleaner-safe-skip-mail-overquota-check');
export const quotaCleanerSafeCheckIsEmpty: boolean = quotaCleanerSafeEnable && features.has('quota-cleaner-safe-check-is-empty');
// Включалка кнопки "Вернуть из сейфа" в чистилке (только для облачных групп)
export const quotaCleanerSafeRestore: boolean = quotaCleanerSafeEnable && features.has('quota-cleaner-safe-restore');
export const quotaCleanerSafeTip: boolean = quotaCleanerSafeEnable && features.has('quota-cleaner-safe-tip');

// Описание – reactApp/appHelpers/featuresHelpers/features/docs/quotaCleanerSafe.md
